import { render, staticRenderFns } from "./UserBar.vue?vue&type=template&id=0cf62fd3&scoped=true&"
import script from "./UserBar.vue?vue&type=script&lang=js&"
export * from "./UserBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf62fd3",
  null
  
)

export default component.exports